import {
    ShieldCheck,
    CheckCircle2,
    XCircle,
    Users,
} from "lucide-react";

function RoleStats({ roles }) {

    const totalRoles = roles.length;

    const activeRoles = roles.filter(
        (role) => role.status === "Active"
    ).length;

    const inactiveRoles = roles.filter(
        (role) => role.status === "Inactive"
    ).length;

    const assignedAdmins = roles.reduce((total, role) => {

        if (role.adminUsers) {

            return total + role.adminUsers.length;

        }

        return total;

    }, 0);

    return (

        <div className="roles-overview">

            <div className="overview-card">

                <ShieldCheck size={24} />

                <div>

                    <h2>{totalRoles}</h2>

                    <p>Total Roles</p>

                </div>

            </div>

            <div className="overview-card">

                <CheckCircle2 size={24} />

                <div>

                    <h2>{activeRoles}</h2>

                    <p>Active Roles</p>

                </div>

            </div>

            <div className="overview-card">

                <XCircle size={24} />

                <div>

                    <h2>{inactiveRoles}</h2>

                    <p>Inactive Roles</p>

                </div>

            </div>

            <div className="overview-card">

                <Users size={24} />

                <div>

                    <h2>{assignedAdmins}</h2>

                    <p>Assigned Admins</p>

                </div>

            </div>

        </div>

    );

}

export default RoleStats;